import { MoreOutlined } from "@ant-design/icons"
import {
  Button,
  type ButtonProps,
  Dropdown,
  type DropdownProps,
  type MenuProps
} from "antd"
import React from "react"

import { getRowActionsPopupContainer } from "./row-actions-popup-container.ts"

interface RowActionsMenuProps {
  items: MenuProps["items"]
  disabled?: boolean
  placement?: DropdownProps["placement"]
  /**
   * Overrides for the trigger, so a table with its own affordance can adopt
   * this without changing how the row looks. The container is not reachable
   * from here — that is the point.
   */
  buttonProps?: Omit<ButtonProps, "icon" | "onClick" | "disabled">
}

/**
 * The "⋯" menu at the end of a table row.
 *
 * Owning the container here rather than passing it at each call site is the
 * point: a table that scrolls its body internally leaves a menu parked on
 * `document.body` hanging over the wrong row, and that only has to be
 * remembered once instead of at every Actions column.
 */
export function RowActionsMenu({
  items,
  disabled = false,
  placement = "bottom",
  buttonProps
}: RowActionsMenuProps) {
  return (
    <Dropdown
      menu={{ items }}
      trigger={["click"]}
      placement={placement}
      getPopupContainer={getRowActionsPopupContainer}
    >
      <Button
        {...buttonProps}
        disabled={disabled}
        // The row underneath opens or edits the record on click.
        onClick={(e) => e.stopPropagation()}
        icon={<MoreOutlined className={"text-md"} />}
      />
    </Dropdown>
  )
}

export default RowActionsMenu
